<template>
<div>
  <NormalSelect
    :selected="_fontLineHeight"
    :options="options"
    :optionValue="'value'"
    :optionLabel="'text'"
    :menuDrop="menuDrop"
    :menuMaxWidth="menuMaxWidth"
    :menuMaxHeight="menuMaxHeight"
    :boundary="boundary"
    @change="onChange"
  />
</div>
</template>

<script>
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";

export default {
  components: {
    NormalSelect,
  },
  props: {
    fontLineHeight: {
      type: [String, Number],
      default: undefined,
    },
    optionSize: {
      type: String,
      default: "default",   // "header", "footer", "heading1", "heading2", "heading3", "heading4", "paragrapg", "link", "default"
    },
    menuDrop: {
      type: String,
      default: undefined,
    },
    menuMaxWidth: {
      type: String,
      default: undefined,
    },
    menuMaxHeight: {
      type: String,
      default: undefined,
    },
    boundary: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      optionsDefault: [
        { value: 0.2, text: "0.2" }, // new
        { value: 0.5, text: "0.5" }, // new
        { value: 0.8, text: "0.8" }, // new
        { value: 1, text: "1.0" },
        { value: 1.2, text: "1.2" }, // new
        { value: 1.4, text: "1.4" }, // new
        { value: 1.5, text: "1.5" },
        { value: 1.6, text: "1.6" },
        { value: 1.8, text: "1.8" },
        { value: 2, text: "2.0" },
        // { value: 2.4, text: "2.4" }, // not v3
        // { value: 2.8, text: "2.8" }, // not v3
        { value: 3, text: "3.0" },
      ],
    };
  },
  computed: {
    options() {
      return this.optionsDefault;
    },
    _fontLineHeight() {
      const value = Array.isArray(this.fontLineHeight)
        ? this.fontLineHeight[0]
        : this.fontLineHeight;
      const findFont = this.options.filter((item) => value && parseFloat(item.value) == parseFloat(value))[0];
      return findFont ? findFont.value : null;
    },
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      this.$emit("input:fontLineHeight", value);
      this.$emit("change:fontLineHeight", value);
      this.$emit("update:fontLineHeight", value);
    },
  },
};
</script>

<style></style>
